import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import placeholder from "../../assets/placeholderImage.jpg" ;
import "./styles.css";
import {getAllNews} from "./functions";
import {baseImagesUrl} from "../../assets/Constants";

const News = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [allNews, setAllNews] = useState([]);

    useEffect(() => {
        (async () => {
            const allNews = await getAllNews();
            setAllNews(allNews);
            document.title = "مدیریت خبرها"
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">مدیریت خبرها</h1>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className={"table text-center"}>
                                    <thead>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>آیدی</th>
                                        <th>تصویر خبر</th>
                                        <th>عنوان</th>
                                        <th>خلاصه</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        allNews.map((news, index) => {
                                            return (
                                                <tr key={news.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{news.id}</td>
                                                    <td>
                                                        <img
                                                            src={news.primaryPicture && news.primaryPicture.includes("news_") ? `${baseImagesUrl}news/${news.primaryPicture}` : placeholder}
                                                            height={100}
                                                        />
                                                    </td>
                                                    <td>{news.title}</td>
                                                    <td>{news.summary}</td>

                                                    <td>
                                                        <Link to={`update/${news.id}`}>
                                                            <FontAwesomeIcon className={"btn"} icon={faPencil}
                                                                             width={20}/>
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <Link to={`update/${news.id}`}>
                                                            <FontAwesomeIcon className={"btn"} icon={faTrash}
                                                                             width={20}/>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default News;